import(/* webpackMode: "eager" */ "/app/apps/israbeton/app/[locale]/not-found.tsx");
